import React from "react";
import { Container } from "react-bootstrap";
import img from "../../../assets/images/contact-image.png";
import { roofSteepness } from "../../../util/constants";
import SelectOption from "../SelectOption";
import { Spring } from "react-spring/renderprops";

const SelectRoofSteepness = ({ setStep, roofData, setRoofData }) => {
  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1500 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              {" "}
              <div>
                <img src={img} className="toast-image" alt="Helper Profile" />
              </div>
              <h5> How steep is your roof?</h5>
            </span>
            <div>
              <div className="roof-selection-section">
                {roofSteepness.map((steepness) => (
                  <SelectOption
                    setStep={setStep}
                    roofData={roofData}
                    setRoofData={setRoofData}
                    type={steepness.name}
                    image={steepness.image}
                    nextStep={3}
                    optionType={"roofSteepness"}
                  />
                ))}
              </div>
            </div>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default SelectRoofSteepness;
